import React from 'react';

const PLGO = () => {
  return (
    <div className="max-w-3xl">
      <h2 className="text-3xl font-bold text-black mb-8">Plattform-Lizenzbedingungen und Geschäftsordnung (PLGO)</h2>
      
      <div className="space-y-6 text-gray-700">
        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 1 Geltungsbereich und Vertragspartner</h3>
          <p className="mb-4">
            Diese Plattform-Lizenzbedingungen und Geschäftsordnung (PLGO) gelten für die Nutzung der KI-Beratungsplattform und -dienste der:
          </p>
          <p className="mb-4">
            <strong>Nadine Rau u. Mike Trepte GbR</strong><br />
            Bettenhäuserstr. 1<br />
            34123 Kassel<br />
            E-Mail: mike.trepte@ki-kundenkommunikation.de<br />
            Telefon: 0561 / 43027276
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 2 Leistungsumfang</h3>
          <p className="mb-4">
            <strong>2.1 Beratungsleistungen:</strong> Wir bieten KI-Beratung und Automatisierungslösungen für kleine und mittlere Unternehmen, Coaches, Berater und Trainer.
          </p>
          <p className="mb-4">
            <strong>2.2 Plattform-Zugang:</strong> Der Zugang zu unseren digitalen Tools und Ressourcen erfolgt nach Vertragsabschluss über unsere Online-Plattform.
          </p>
          <p className="mb-4">
            <strong>2.3 Individuelle Lösungen:</strong> Alle KI-Implementierungen werden individuell auf die Bedürfnisse des Kunden angepasst.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 3 Nutzungsrechte und Lizenzen</h3>
          <p className="mb-4">
            <strong>3.1 Lizenzgewährung:</strong> Der Kunde erhält ein einfaches, nicht übertragbares Nutzungsrecht für die bereitgestellten KI-Lösungen.
          </p>
          <p className="mb-4">
            <strong>3.2 Nutzungsbeschränkungen:</strong> Die Weitergabe, der Verkauf oder die Unterlizenzierung der bereitgestellten Lösungen an Dritte ist untersagt.
          </p>
          <p className="mb-4">
            <strong>3.3 Geistiges Eigentum:</strong> Alle Rechte an den entwickelten KI-Lösungen und der verwendeten Technologie verbleiben bei K³.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 4 Pflichten des Kunden</h3>
          <p className="mb-4">
            <strong>4.1 Datenbereitstellung:</strong> Der Kunde verpflichtet sich, alle für die KI-Implementierung notwendigen Daten vollständig und wahrheitsgemäß bereitzustellen.
          </p>
          <p className="mb-4">
            <strong>4.2 Datenschutz-Compliance:</strong> Der Kunde gewährleistet, dass alle übermittelten Daten datenschutzkonform erhoben wurden.
          </p>
          <p className="mb-4">
            <strong>4.3 Systemvoraussetzungen:</strong> Der Kunde stellt sicher, dass die technischen Voraussetzungen für die KI-Integration erfüllt sind.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 5 Preise und Zahlungsbedingungen</h3>
          <p className="mb-4">
            <strong>5.1 Vergütung:</strong> Die Vergütung richtet sich nach dem individuell vereinbarten Angebot.
          </p>
          <p className="mb-4">
            <strong>5.2 Zahlungsziel:</strong> Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zu begleichen.
          </p>
          <p className="mb-4">
            <strong>5.3 Verzug:</strong> Bei Zahlungsverzug können wir Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz geltend machen.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 6 Vertragslaufzeit und Kündigung</h3>
          <p className="mb-4">
            <strong>6.1 Laufzeit:</strong> Die Vertragslaufzeit ergibt sich aus der individuellen Vereinbarung.
          </p>
          <p className="mb-4">
            <strong>6.2 Ordentliche Kündigung:</strong> Der Vertrag kann mit einer Frist von 4 Wochen zum Monatsende gekündigt werden.
          </p>
          <p className="mb-4">
            <strong>6.3 Außerordentliche Kündigung:</strong> Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 7 Haftung und Gewährleistung</h3>
          <p className="mb-4">
            <strong>7.1 Haftungsbeschränkung:</strong> Unsere Haftung ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.
          </p>
          <p className="mb-4">
            <strong>7.2 KI-Performance:</strong> Wir gewährleisten die Funktionsfähigkeit der KI-Lösungen nach dem Stand der Technik, können aber keine 100%ige Genauigkeit garantieren.
          </p>
          <p className="mb-4">
            <strong>7.3 Datensicherheit:</strong> Wir setzen angemessene technische und organisatorische Maßnahmen zum Schutz der Kundendaten ein.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 8 Datenschutz</h3>
          <p className="mb-4">
            <strong>8.1 Datenverarbeitung:</strong> Die Verarbeitung personenbezogener Daten erfolgt ausschließlich im Rahmen unserer Datenschutzerklärung.
          </p>
          <p className="mb-4">
            <strong>8.2 KI-Training:</strong> Kundendaten werden nicht für das Training allgemeiner KI-Modelle verwendet, sondern nur für kundenspezifische Lösungen.
          </p>
          <p className="mb-4">
            <strong>8.3 Auftragsverarbeitung:</strong> Bei der Nutzung externer KI-Dienste werden entsprechende Auftragsverarbeitungsverträge abgeschlossen.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-black mb-2">§ 9 Schlussbestimmungen</h3>
          <p className="mb-4">
            <strong>9.1 Anwendbares Recht:</strong> Es gilt das Recht der Bundesrepublik Deutschland.
          </p>
          <p className="mb-4">
            <strong>9.2 Gerichtsstand:</strong> Gerichtsstand ist Kassel, sofern der Kunde Kaufmann ist.
          </p>
          <p className="mb-4">
            <strong>9.3 Salvatorische Klausel:</strong> Sollten einzelne Bestimmungen unwirksam sein, berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mt-8">
          <p className="text-sm text-gray-600">
            <strong>Stand:</strong> Januar 2025<br />
            <strong>Version:</strong> 1.0
          </p>
        </div>
      </div>
    </div>
  );
};

export default PLGO;